export const queryKeys = {
  session: () => ['session'],
  festivals: (type = 'all') => ['festivals', type],
  festival: (id) => ['festival', id ?? 'none'],
  stages: (festivalId) => ['stages', festivalId ?? 'none'],
  performances: (festivalId) => ['performances', festivalId ?? 'none'],
  performers: () => ['performers'],
  performerTypes: () => ['performerTypes'],
  vendors: () => ['vendors', 'all'],
  vendorCategories: () => ['vendorCategories'],
  festivalVendors: (festivalId) => ['festivalVendors', festivalId ?? 'none'],
  services: (festivalId) => ['services', festivalId ?? 'none'],
  serviceTypes: () => ['serviceTypes'],
  sponsors: (festivalId) => ['sponsors', festivalId ?? 'none'],
  sponsorsForObject: (festivalId, objectType, objectId) => [
    'sponsorsForObject',
    festivalId ?? 'none',
    objectType,
    objectId ?? 'none',
  ],
  faqs: (festivalId) => ['faqs', festivalId ?? 'none'],
  attractions: (festivalId) => ['attractions', festivalId ?? 'none'],
  orgMembers: () => ['orgMembers'],
};
